import { PluginFunction } from "vue";
import { formatter } from "@/ui/_utils/formatter";

export const formatterPlugin: PluginFunction<void> = vue => {
  vue.prototype.$formatter = formatter;
};
